import { Button, ButtonProps, forwardRef } from '@chakra-ui/react';

export interface AppButtonProps extends ButtonProps {}

export const AppButton = forwardRef((props: AppButtonProps, ref: any) => {
  const { type, ...others } = props;

  const variant =
    (props.variant && props.variant) ||
    (props.type === 'submit' && 'solid') ||
    'outline';

  return (
    <Button
      ref={ref}
      {...others}
      variant={variant}
      colorScheme={props.colorScheme || 'blue'}
    />
  );
});
